<template>
  <div>
    <input 
      ref="uploader2" 
      class="d-none" 
      type="file" 
      @change="handleFileUploadFront($event)"
    />

    <div class="pa-0 ma-0">
      <div v-if="this.user" class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div class="overlay-grey-web">
              <!-- Header Section -->
              <div class="plan-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-star-circle</v-icon>
                  <h1 class="header-title">Your Plan</h1>
                </div>
                <p class="header-subtitle">
                  Choose the perfect plan for your music experience
                </p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Subscriptions Section -->
              <div class="subscriptions-section">
                <h2 class="section-title">
                  <v-icon left>mdi-wallet-membership</v-icon>
                  Subscriptions
                </h2>

                <div class="plans-grid">
                  <!-- Free Plan -->
                  <v-card :class="{'plan-card': true, 'plan-active': user.level >= 0}">
                    <div class="plan-badge" v-if="user.level === 0">
                      <v-icon size="16">mdi-check-circle</v-icon>
                      Active
                    </div>
                    <div class="plan-header-card">
                      <h3 class="plan-title">Free</h3>
                      <v-img
                        :src="require('@/assets/images/muzible_muze.webp')"
                        class="plan-image"
                        cover
                      ></v-img>
                    </div>
                    <v-card-text class="plan-content">
                      <p class="plan-description">
                        Access to all free stream catalogues, no data limit, free music anywhere you go. 
                        Variable bitrate depending on the internet speed.
                      </p>
                      <div class="plan-features">
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span>Access to <strong>free</strong> streams</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Up to 320kbps</strong> stream quality</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>AI Muze</strong> free model access</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span>and more..</span>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-actions class="plan-actions">
                      <v-btn
                        :disabled="true"
                        variant="outlined"
                        block
                        class="plan-btn"
                      >
                        {{ user.level === 0 ? 'Active' : 'Active' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <!-- Premium Plan -->
                  <v-card :class="{'plan-card': true, 'plan-active': user.level >= 1}">
                    <div class="plan-badge" v-if="user.level === 1">
                      <v-icon size="16">mdi-check-circle</v-icon>
                      Active
                    </div>
                    <div class="plan-header-card">
                      <h3 class="plan-title">Premium</h3>
                      <v-img
                        :src="require('@/assets/images/muzible_verse.webp')"
                        class="plan-image"
                        cover
                      ></v-img>
                    </div>
                    <v-card-text class="plan-content">
                      <p class="plan-description">
                        Access to all premium stream catalogues with up to 768kbps stream quality, 
                        depending on the internet speed. Geo location music and many more..
                      </p>
                      <div class="plan-features">
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Full access</strong> to all streams</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Up to 768kbps</strong> stream quality</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>AI Muze</strong> premium access</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span>and more..</span>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-actions class="plan-actions">
                      <v-btn
                        :disabled="true"
                        variant="outlined"
                        block
                        class="plan-btn"
                        @click="purchasePlan(1)"
                      >
                        {{ user.level >= 1 ? 'Active' : 'Subscribe - 15$' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>

                  <!-- Max Plan -->
                  <v-card :class="{'plan-card': true, 'plan-active': user.level >= 2}">
                    <div class="plan-badge" v-if="user.level === 2">
                      <v-icon size="16">mdi-check-circle</v-icon>
                      Active
                    </div>
                    <div class="plan-header-card">
                      <h3 class="plan-title">Max</h3>
                      <v-img
                        :src="require('@/assets/images/muzible_tickets.webp')"
                        class="plan-image"
                        cover
                      ></v-img>
                    </div>
                    <v-card-text class="plan-content">
                      <p class="plan-description">
                        Access to all stream catalogues including lossless streams and Dolby Atmos.
                      </p>
                      <div class="plan-features">
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Full access</strong> to all streams</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Lossless</strong> (FLAC/ALAC) quality</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>Dolby Atmos</strong></span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span><strong>AI Muze</strong> priority access</span>
                        </div>
                        <div class="feature-item">
                          <v-icon size="20">mdi-check</v-icon>
                          <span>and more..</span>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-actions class="plan-actions">
                      <v-btn
                        :disabled="true"
                        variant="outlined"
                        block
                        class="plan-btn"
                        @click="purchasePlan(2)"
                      >
                        {{ user.level >= 2 ? 'Active' : 'Subscribe - 25$' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Creator Verification Section -->
              <div class="creator-section">
                <h2 class="section-title">
                  <v-icon left>mdi-shield-check</v-icon>
                  Creator Verification
                </h2>

                <v-card class="creator-card">
                  <div class="plan-badge" v-if="user.creator_verified === 1">
                    <v-icon size="16">mdi-check-circle</v-icon>
                    Verified
                  </div>
                  <div class="plan-header-card">
                    <h3 class="plan-title">Creator</h3>
                    <v-img
                      :src="require('@/assets/images/muzible_11_42.webp')"
                      class="plan-image"
                      cover
                    ></v-img>
                  </div>
                  <v-card-text class="plan-content">
                    <p class="plan-description">
                      Verified Creators can create artists or/and link to existing ones. 
                      Ideal solution for bands and artists that wants full control. Advanced statistics. 
                      Verification ensure that no one impersonate you on the platform. 
                      It's your music and your right to know everything about it and your fans. No more intermediaries. 
                      If you are already in the streaming platform as an Artist - you can link your account and view all the data.
                    </p>
                    <div class="plan-features">
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>Create artist</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>Link existing artist with your account</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>Create albums</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>Streaming statistics</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>One time verification payment</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>Direct payments - no intermediaries</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>NFT Music Albums</span>
                      </div>
                      <div class="feature-item">
                        <v-icon size="20">mdi-check</v-icon>
                        <span>GEO Music and many more..</span>
                      </div>
                    </div>

                    <!-- KYC Warning -->
                    <v-alert
                      v-if="user.kyc === 0 && user.kyc_corp === 0"
                      type="warning"
                      variant="outlined"
                      class="kyc-alert mt-4"
                    >
                      <div class="alert-content">
                        <div class="alert-title">KYC Verification Required</div>
                        <div class="alert-text">
                          KYC Verification is mandatory to proceed with Creator verification.
                        </div>
                        <v-btn
                          variant="outlined"
                          size="small"
                          class="mt-3"
                          @click="handleClickMenu('settings')"
                        >
                          Go to KYC verification
                        </v-btn>
                      </div>
                    </v-alert>
                  </v-card-text>
                  <v-card-actions class="plan-actions">
                    <v-btn
                      :disabled="user.creator_verified === 1 || user.creator_verification_inprogress === 1 || user.creator_verified_paid === 1 || (user.kyc === 0 && user.kyc_corp === 0) || true"
                      variant="outlined"
                      block
                      class="plan-btn"
                      @click="purchasePlanCreator()"
                    >
                      {{ user.creator_verified === 0 ? (user.creator_verification_inprogress === 1 ? 
                      'Verification in progress' : (user.creator_verified_paid === 1 ? 
                      'Upload documents below..' : 'Verify - 100$')) : 'Verified' }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Verification Documents Section -->
              <div class="documents-section">
                <h2 class="section-title">
                  <v-icon left>mdi-file-document-check</v-icon>
                  Verification Documents
                  <span v-if="user.creator_verified_paid === 0" class="status-disabled">(Disabled - Not Paid)</span>
                </h2>

                <v-alert
                  type="info"
                  variant="outlined"
                  class="documents-info-alert mb-4"
                >
                  <div class="alert-content">
                    <div class="alert-title">Document Requirements</div>
                    <div class="alert-text">
                      Please upload a document that confirms that you have the rights to the works you upload to the site, 
                      either personal or corporate rights to the artist's name, songs, albums, etc. Please merge all needed documents in one file.
                      After successful verification you will be able to create artists, and start uploading music. Please bear in mind that 
                      after verification you hold the full responsibility for the content you upload. Infringement of any kind will result in 
                      immediate account suspension and legal actions. Upload only your own content or content you have the rights to. 
                      If you don't have any specific document, please create a simple one that states that you have the rights to the content you upload, 
                      it must include your signature.
                    </div>
                  </div>
                </v-alert>

                <!-- Document Upload -->
                <v-card class="document-upload-card">
                  <v-card-text>
                    <div class="upload-section">
                      <div class="upload-info">
                        <h3 class="upload-title">Confirmation Document</h3>
                        <div class="upload-status" :class="getStatusClass(user.creator_doc_verified, user.creator_doc)">
                          <v-icon left size="20">{{ getStatusIcon(user.creator_doc_verified, user.creator_doc) }}</v-icon>
                          <span>{{ GetKYCInfo(user.creator_doc_verified, user.creator_doc) }}</span>
                        </div>
                      </div>
                      <v-btn
                        :loading="isSelectingFront"
                        :disabled="user.creator_doc_verified ? true : (user.creator_verified_paid === 1 ? false : true)"
                        variant="outlined"
                        prepend-icon="mdi-upload"
                        class="upload-btn"
                        @click="triggerUploadFront()"
                      >
                        Upload Document
                      </v-btn>
                    </div>

                    <!-- Upload Progress -->
                    <v-progress-linear
                      v-if="isUploadingFront"
                      :model-value="progressUpF"
                      color="white"
                      height="4"
                      class="mt-4"
                    ></v-progress-linear>
                    <div v-if="isUploadingFront" class="upload-progress-text">
                      Uploading... {{ progressUpF }}%
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Consent Section -->
              <div class="consent-section">
                <h2 class="section-title">
                  <v-icon left>mdi-file-sign</v-icon>
                  Consent
                </h2>

                <v-card class="consent-card">
                  <v-card-text>
                    <v-form ref="formsignup" v-model="valid" id="check-signup-form">
                      <div class="consent-content">
                        <v-checkbox
                          v-model="checkboxSignup"
                          :disabled="user.creator_confirmed === 1 || user.creator_verified_paid === 0"
                          :rules="[v => !!v || 'Consent required']"
                          required
                          hide-details
                          color="white"
                          class="consent-checkbox"
                        >
                          <template v-slot:label>
                            <span class="consent-text">
                              I hereby confirm that I have the rights to the works I upload to the site, 
                              either personal or corporate rights to the artist's name, songs, albums, etc. 
                              I understand that after successful verification, 
                              I will be able to create artists and start uploading music. 
                              I acknowledge that I hold full responsibility for the content I upload and that infringement of any kind will 
                              result in immediate account suspension and legal actions.
                            </span>
                          </template>
                        </v-checkbox>
                      </div>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="consent-actions">
                    <v-btn
                      type="submit"
                      form="check-signup-form"
                      :disabled="!valid || user.creator_confirmed === 1 || user.creator_verified_paid === 0"
                      variant="outlined"
                      block
                      class="consent-btn"
                      @click="consent($event)"
                    >
                      <span v-if="user.creator_confirmed === 0">Send Consent</span>
                      <span v-if="user.creator_confirmed === 1">Consent Received</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>

            </div>
          </div>
        </div>
        <v-row
          :style="(isMobileXs || isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:123px!important'"
        ></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Plan',

  components: {},
  data: () => ({
    navbar: false,
    user: null,
    valid: false,

    isUploadingFront: false,
    progressUpF: 0,
    isSelectingFront: false,
    selectedFileF: null,
    checkboxSignup: '',
  }),
  mounted() {
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {},
  destroyed() {},
  watch: {
    '$store.state.user': function () {
      this.user = this.$store.getters.getUserData;
    },
  },
  computed: {
    isfullScreen() {
      if (this.isMobile && this.isMobileXs) {
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
      return this.$store.getters.getUserData != null
    },
    isDesktop() {
      if (!this.navbar) {
        return true;
      } else {
        return false;
      }
    },
    getGextPanel() {
      if (this.navbar) {
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
  },
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;
      this.checkboxSignup = this.user.creator_confirmed === 1 ? true : false;

      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      this.emitter.on('progressUploadCreator', (progress) => {
        this.progressUpF = progress;
      })
    }
  },
  methods: {
    getStatusClass(verified, value) {
      if (verified === 1) {
        return 'status-verified';
      } else if (value === '') {
        return 'status-not-verified';
      } else {
        return 'status-pending';
      }
    },
    getStatusIcon(verified, value) {
      if (verified === 1) {
        return 'mdi-check-circle';
      } else if (value === '') {
        return 'mdi-alert-circle';
      } else {
        return 'mdi-clock-outline';
      }
    },
    consent(e) {
      this.valid = false;

      this.$store.dispatch('consent', {
        token: this.user.token
      }
      ).then(response => {
        this.user = this.$store.getters.getUserData;
        this.checkboxSignup = this.user.creator_confirmed === 1 ? true : false;
        this.notify('Consent accepted');
      }).catch(error => {
        this.notifyError("Error occured.. Please try again later.");
      });

      e.preventDefault()
    },
    triggerUploadFront() {
      this.isSelectingFront = true;
      window.addEventListener('focus', () => {
        this.isSelectingFront = false
      }, { once: true });

      this.$refs.uploader2.click();
    },
    handleFileUploadFront(e) {
      this.selectedFileF = e.target.files[0];

      if (this.selectedFileF) {
        this.isSelectingFront = true;
        let formData = new FormData();
        formData.append('file', this.selectedFileF);
        formData.append('uid', this.user.uid);
        formData.append('size', parseFloat(((this.selectedFileF.size / 1024) / 1024).toFixed(2)));

        this.isUploadingFront = true;
        this.progressUpF = 0;
        this.$store.dispatch('upload2faFileCreator', { 
          formData: formData,
          token: this.user.token
        }).then(response => {
          this.isSelectingFront = false;
          this.selectedFileF = null;
          this.isUploadingFront = false;
          this.user = this.$store.getters.getUserData;
        }).catch(error => {
          this.isSelectingFront = false;
          this.selectedFileF = null;
          this.isUploadingFront = false;
          this.notifyError("Error occured.. Please try again later.");
        })
      }
    },
    GetKYCInfo(verified, value) {
      if (verified === 1) {
        return 'Verified';
      } else if (value === '') {
        return 'Not Verified';
      } else {
        return 'Verification in progress';
      }
    },
    purchasePlan(level) {
      if (this.user.level < level) {
        this.$store.dispatch('setUserLevel', { email: this.user.email, token: this.user.token, level: level }).then(response => {
          this.user = this.$store.getters.getUserData;
          this.notify('Subscription plan activated');
        }).catch(error => {
          this.notifyError("Error occured.. Please try again later.");
        })
      } else {
        this.notifyError('Subscription plan already activated');
      }
    },
    purchasePlanCreator() {
      this.$store.dispatch('setUserCreatorVerify', { token: this.user.token }).then(response => {
        this.user = this.$store.getters.getUserData;
        this.notify('Creator Verification paid');
      }).catch(error => {
        this.notifyError("Error occured.. Please try again later.");
      })
    },

    checkScreenSize() {
      if (window.innerWidth > 768) {
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link) {
      if (link === 'TryMuzE') {
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse') {
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Plan Header */
.plan-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

/* Section Title */
.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-disabled {
  font-size: 18px;
  color: #e2474b;
  margin-left: 8px;
}

/* Subscriptions Section */
.subscriptions-section {
  margin-bottom: 32px;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

@media (max-width: 768px) {
  .plans-grid {
    grid-template-columns: 1fr;
  }
}

/* Plan Card */
.plan-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  animation: slideIn 0.4s ease forwards;
}

.plan-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.plan-card.plan-active {
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 16px rgba(255, 255, 255, 0.1);
}

.plan-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.9);
  color: black;
  padding: 6px 12px;
  border-radius: 20px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
}

.plan-header-card {
  padding: 24px 24px 0 24px;
}

.plan-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin-bottom: 16px;
  text-align: center;
}

.plan-image {
  height: 120px;
  border-radius: 12px;
  margin-bottom: 16px;
}

.plan-content {
  padding: 16px 24px;
}

.plan-description {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 20px;
}

.plan-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);

  strong {
    font-weight: 600;
  }
}

.plan-actions {
  padding: 16px 24px 24px 24px;
}

.plan-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
}

.plan-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Creator Section */
.creator-section {
  margin-bottom: 32px;
}

.creator-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  animation: slideIn 0.4s ease forwards;
  padding: 8px;
}

.creator-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

/* Alerts */
.kyc-alert,
.documents-info-alert {
  background: rgba(255, 152, 0, 0.1) !important;
  border: 1px solid rgba(255, 152, 0, 0.4) !important;
  border-radius: 12px !important;

  :deep(.v-alert__content) {
    color: white !important;
  }
}

.documents-info-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border: 1px solid rgba(33, 150, 243, 0.4) !important;
}

.alert-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
}

.alert-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

/* Documents Section */
.documents-section {
  margin-bottom: 32px;
}

.document-upload-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: slideIn 0.4s ease forwards;
}

.upload-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  padding: 16px;
}

.upload-info {
  flex: 1;
  min-width: 200px;
}

.upload-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: white;
  margin-bottom: 12px;
}

.upload-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  font-weight: 600;
  width: fit-content;
}

.status-verified {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid #4caf50;
}

.status-not-verified {
  background: rgba(226, 71, 75, 0.2);
  color: #e2474b;
  border: 1px solid #e2474b;
}

.status-pending {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
  border: 1px solid #ff9800;
}

.upload-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
  min-width: 180px;
}

.upload-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.upload-progress-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin-top: 8px;
}

/* Consent Section */
.consent-section {
  margin-bottom: 32px;
}

.consent-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: slideIn 0.4s ease forwards;
}

.consent-content {
  padding: 16px 0;
}

.consent-checkbox {
  :deep(.v-label) {
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 15px !important;
    color: rgba(255, 255, 255, 0.9) !important;
    line-height: 1.6 !important;
  }
}

.consent-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
}

.consent-actions {
  padding: 16px 24px 24px 24px;
}

.consent-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
}

.consent-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.plan-header,
.subscriptions-section,
.creator-section,
.documents-section,
.consent-section {
  animation: slideIn 0.4s ease forwards;
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .upload-section {
    flex-direction: column;
    align-items: stretch;
  }

  .upload-btn {
    width: 100%;
  }
}

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}
</style>